import alt from 'components/Dispatcher';

class CallerTeamComboboxSearchFieldActions {
  constructor() {
    this.generateActions(
      'searchReps',
      'searchRepsLoading',
      'searchRepsSuccess',
      'searchRepsError',

      'searchManagers',
      'searchManagersLoading',
      'searchManagersSuccess',
      'searchManagersError',

      'searchTeams',
      'searchTeamsLoading',
      'searchTeamsSuccess',
      'searchTeamsError',

      'changeCaller',
      'removeCaller',
      'resetCaller',

      'fetchSelectedReps',
      'fetchSelectedRepsLoading',
      'fetchSelectedRepsSuccess',
      'fetchSelectedRepsError',

      'fetchSelectedManagers',
      'fetchSelectedManagersLoading',
      'fetchSelectedManagersSuccess',
      'fetchSelectedManagersError',

      'fetchSelectedTeams',
      'fetchSelectedTeamsLoading',
      'fetchSelectedTeamsSuccess',
      'fetchSelectedTeamsError',

      'changeSelectedDepartment'
    );
  }
}

export default alt.createActions(CallerTeamComboboxSearchFieldActions);
